import React, { useEffect, useState } from 'react';
import { useAuthContext } from '@repo/hooks';
import { apiRequest } from '@repo/utils/helpers/api';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsButton,
} from '@views/Settings/components';
import { LoaderIcon } from '@repo/icons';
import styles from './DeleteAccount.module.scss';
import DeleteAccountModal from '@views/Settings/components/DeleteAccountModal';

export default function DeleteAccount() {
  const { cleanupAndLogout, getEntitlementValue } = useAuthContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const deleteAccount = () => {
    setError(null);
    setIsDeleting(true);

    apiRequest('DELETE', '/users/self/')
      .then(cleanupAndLogout)
      .catch(() => {
        // Not going to worry about cancellation if user leaves view before completion, that would be a very edgy edge case
        // We might consider dispatching an alert to the alerts UI here, though...
        setError(true);
        setIsDeleting(false);
      });
  };

  useEffect(() => {
    if (error) {
      setModalOpen(true);
    }
  }, [error]);

  return (
    getEntitlementValue('account.delete') && (
      <>
        <Section>
          <SettingsSectionLabel>Danger Zone</SettingsSectionLabel>
          <SettingsSectionBox className={styles.box}>
            Delete Clay account
            <SettingsButton onClick={() => setModalOpen(true)} className={styles.deleteButton}>
              {isDeleting ? 'Deleting...' : 'Delete Account'}
              {isDeleting && <LoaderIcon />}
            </SettingsButton>
            <p>Permanently delete your account</p>
          </SettingsSectionBox>
        </Section>
        <DeleteAccountModal
          accountType="account"
          isOpen={modalOpen}
          closeModal={() => setModalOpen(false)}
          deleteAccount={deleteAccount}
          isDeleting={isDeleting}
          error={error}
        />
      </>
    )
  );
}
